export default function FloatingCTA() {
  const handlePhoneClick = () => {
    window.location.href = 'tel:080-7347-9482';
  };

  const handleLineClick = () => {
    window.open('https://lin.ee/FOUdDfw', '_blank');
  };

  return (
    <>
      {/* Mobile: Bottom Fixed Buttons */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.15)] border-t border-gray-200">
        <div className="grid grid-cols-2 gap-0">
          <button
            onClick={handlePhoneClick}
            className="flex items-center justify-center gap-2 py-4 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-bold text-base active:scale-95 transition-transform"
          >
            <i className="ri-phone-fill text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>電話する</span>
          </button>
          <button
            onClick={handleLineClick}
            className="flex items-center justify-center gap-2 py-4 bg-[#00B900] text-white font-bold text-base active:scale-95 transition-transform"
          >
            <i className="ri-line-fill text-xl w-5 h-5 flex items-center justify-center"></i>
            <span>LINE相談</span>
          </button>
        </div>
      </div>

      {/* Desktop: Right Bottom Floating Buttons */}
      <div className="hidden md:flex fixed bottom-8 right-8 z-50 flex-col gap-3">
        <button
          onClick={handlePhoneClick}
          className="flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-bold text-base rounded-full shadow-[0_8px_30px_rgba(255,107,53,0.4)] hover:scale-105 hover:shadow-[0_12px_40px_rgba(255,107,53,0.5)] transition-all whitespace-nowrap"
        >
          <i className="ri-phone-fill text-xl w-5 h-5 flex items-center justify-center"></i>
          <span>電話する</span>
        </button>
        <button
          onClick={handleLineClick}
          className="flex items-center gap-3 px-6 py-4 bg-[#00B900] text-white font-bold text-base rounded-full shadow-[0_8px_30px_rgba(0,185,0,0.4)] hover:scale-105 hover:shadow-[0_12px_40px_rgba(0,185,0,0.5)] transition-all whitespace-nowrap"
        >
          <i className="ri-line-fill text-xl w-5 h-5 flex items-center justify-center"></i>
          <span>LINE相談</span>
        </button>
      </div>
    </>
  );
}